/**
 * Gestion réactive de l'état pour le module HorraireCommerce.
 *
 * Ce module exporte les éléments suivants :
 * - isStepTwoActivated / isStepThreeActivated : indiquent l’activation des différentes étapes du processus d’ajout/modification des horaires.
 * - form_HorraireCommerceBody : données réactives pour la création d’un nouvel horaire.
 * - form_HorraireCommerceBodyUpdate : données réactives pour la modification d’un horaire existant.
 * - idToDeleteHorraireCommerce : identifiant de l’horaire à supprimer.
 * - idToAddValueHorraireCommerce : identifiant utilisé pour ajouter une valeur liée à l’horaire.
 * - pageHorraireCommerce : numéro de page actuel pour la pagination des horaires.
 * - searchQueryHorraireCommerce : terme de recherche pour filtrer les horaires.
 * - HorraireCommerceId : identifiant du commerce lié à l’horaire.
 * - errorMessage : message d’erreur éventuel lors de la manipulation des horaires.
 * - isAtcivatedHorraireCommerceWatch : indicateur de suivi réactif pour certaines modifications.
 *
 * Utilise les fonctions réactives de Vue 3 (ref et reactive) pour gérer l'état.
 */

import { reactive, ref } from 'vue';
import type { INewScheduleItem } from '@/types/horraire.commerce.types';

export const isStepTwoActivated = ref(false);
export const isStepThreeActivated = ref(false);

export const form_HorraireCommerceBody = reactive<INewScheduleItem>({
  type: null,
  weekday: null,
  day: null,
  open: null,
  close: null,
});

export const form_HorraireCommerceBodyUpdate = reactive<INewScheduleItem>({
  type: null,
  weekday: null,
  day: null,
  open: null,
  close: null,
});

export const idToDeleteHorraireCommerce = ref<null | string>(null);
export const idToAddValueHorraireCommerce = ref<null | string>(null);
export const isUpatedHorraireCommerce = ref(false);
export const isDeletedHorraireCommerce = ref(false);
export const HorraireCommerce_page = ref(1);
export const searchQueryHorraireCommerce = ref('');
export const HorraireCommerce_id = ref(null);

export const errorMessage = ref<string | null>(null);
export const horraire_commerce = ref<any[]>([
  {
    type: '',
    weekday: '',
    day: '',
    open: '',
    close: '',
  },
]);

export const isAtcivatedHorraireCommerceWatch = ref(false);
